import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ProductUnitPrice from '../../../../../common/product/ProductOverview/ProductUnitPrice';
import { checkIsRiyal, priceDisplayFormat } from '@app/utils/paymentUtils';
import { isRTLLang } from '@app/utils';
import { PCC_RELEASE_CURRENCY_SYMBOL_UPDATE_FOR_SAUDI_RIYAL } from '@app/constants/featureFlags';

const ProductPrice = ({ productId }) => {
  const price = useSelector(
    s => s.products.priceAndAvailability?.[productId]?.discountedPrice
  );
  const unitPrice = useSelector(
    s => s.products.priceAndAvailability?.[productId]?.unitPrice
  );
  const currency = useSelector(s => s.dealerCustomer?.currency);
  const langId = useSelector(s => s.common?.langId);
  const isRTL = isRTLLang(langId);
  const currencySymbolFeatureFlag = useSelector(
    state =>
      state?.featureFlag?.[PCC_RELEASE_CURRENCY_SYMBOL_UPDATE_FOR_SAUDI_RIYAL]
  );
  const isRiyal = currencySymbolFeatureFlag && checkIsRiyal(currency);

  return (
    <div className="col-12 col-lg-auto py-2">
      <p className="text-xxl text-univers--bold u-color--ExtraDarkGray">
        {isRiyal
          ? priceDisplayFormat({
              price: price,
              currency,
              priceWrapperClasses: 'px-1',
              isRTL: isRTL,
              size: 'lg'
            })
          : priceDisplayFormat({
              price: price,
              currency
            })}
      </p>
      <ProductUnitPrice
        currency={currency}
        price={price}
        unitPrice={unitPrice}
      />
    </div>
  );
};

ProductPrice.propTypes = {
  productId: PropTypes.string
};

export default ProductPrice;